export default {
  computed: {
    fields () {
      return [
        { 
          label: this.$t('invoice.fields.order.deliveryNumber'),
          key: 'number', 
          isSortable: true 
        },
        {
          label: this.$t('invoice.fields.order.salesOrderNumber'),
          key: 'sales_order.number',
          isSortable: true
        },
        {
          label: this.$t('invoice.fields.order.shipmentNumber'),
          key: 'shipment_number',
          isSortable: true
        },
        {
          label: this.$t('invoice.fields.order.licensePlate'),
          key: 'fleet_task.vehicle.license_plate'
        },
        {
          label: this.$t('invoice.fields.order.driver'),
          key: 'fleet_task.driver_user.name'
        },
        {
          label: this.$t('invoice.fields.order.deliveryStatus'),
          key: 'status.name'
        },
        {
          label: this.$t('delivery.fields.originAddress'),
          key: 'origin_address.name'
        },
        {
          label: this.$t('delivery.fields.destinationAddress'),
          key: 'destination_address.name'
        },
        {
          label: this.$t('invoice.fields.order.totalLoad'),
          key: 'load_count'
        },
        {
          label: this.$t('delivery.fields.loadWeight'),
          key: 'load_weight'
        },
        {
          label: this.$t('delivery.fields.loadVolume'),
          key: 'load_volume'
        }
      ]
    }
  }
} 